<template>
  <div v-if="showModalFilterSearch" class="modal modal--full-fixed modal-filter-search hide-desktop">
    <div slot="body" class="full-height">
      <div class="modal-body">
        <template v-if="seeAllBrands">
          <div class="modal-header">
            <h5 class="modal-heading">Brands</h5>
            <a href="" class="modal-dismiss" @click.prevent="(seeAllBrands = false), (brandSearch = '')">
              <i class="icon_close"></i>
            </a>
          </div>
          <div class="section section--brands showing-all-brands filter-group--by-brand">
            <ul v-if="$route.name === 'Category' || $route.name === 'Search'" class="tabs tabs-brand">
              <li :class="{ active: activeTab === 0 }">
                <a href="" title="Brand Name" @click.prevent="activeTab = 0">Brand name</a>
              </li>
              <li :class="{ active: activeTab === 1 }">
                <a href="" title="Brand Origins" @click.prevent="activeTab = 1">Brand origin</a>
              </li>
            </ul>
            <div class="section-brand-wrapper">
              <div class="search-with-icon">
                <input
                  ref="typeBrand"
                  v-model="brandSearch"
                  type="text"
                  name="search"
                  class="form-control search-with-icon__input"
                  placeholder="Search brand..."
                  @focus="onFocusShowAllBrands()"
                />
              </div>

              <ul v-if="listSelectedBrand.active.length" class="list-inline list-scrollable list-active-brand">
                <li v-for="(brand, key) in listSelectedBrand.active" :key="key">
                  <a href="" class="pill" @click.prevent>
                    {{ activeTab === 0 ? brand.name : brand.country }}
                    <span class="pill-dismiss" @click.self="removeSelectedBrand(key, activeTab)"></span>
                  </a>
                </li>
              </ul>

              <ul :class="{ expand: listSelectedBrand.length }" class="list-scrollable list-scrollable--letters">
                <li
                  v-for="(letter, key) in letters"
                  :key="`brand-${key}`"
                  :class="{
                    active: letter.isActive,
                    selected: letter.isActive && key === clickedBrand,
                  }"
                >
                  <a @click.prevent="() => (letter.isActive ? scrollToBrandMenu('brand-' + key) : null)">
                    {{ key }}
                  </a>
                </li>
              </ul>

              <div class="side-checkbox" :class="{ 'selected-height': filteredBrands.length }">
                <p v-if="isEmptyWhenTypingBrand" class="empty-typing-brand">No results found</p>
                <ul v-if="filteredBrands.length" id="brand-list-by-filter">
                  <li
                    v-for="(brand, key) in filteredBrands"
                    :id="buildIdElBrand(brand, key)"
                    :key="key"
                    :class="[{ hidden: brand.isHidden }, 'for-br-' + brand.name[0].toLowerCase()]"
                  >
                    <input
                      v-if="activeTab === 0"
                      :id="'filterbrand-' + brand._id"
                      v-model="selectedBrand"
                      type="checkbox"
                      :value="brand._id"
                      name="filterbrand_mobile"
                      class="checkbox"
                    />
                    <input
                      v-else
                      :id="'filterbrand-' + brand._id"
                      v-model="selectedOrigin"
                      type="checkbox"
                      :value="brand.country_tag_id"
                      name="filterbrand_mobile"
                      class="checkbox"
                    />
                    <label :for="'filterbrand-' + brand._id">
                      <img
                        v-if="activeTab === 1 && brand.flag"
                        :src="brand.flag"
                        width="20"
                        height="14"
                        :alt="brand.country"
                        class="flag-brand"
                      />
                      {{ activeTab === 0 ? brand.name : brand.country }}
                    </label>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="modal-header">
            <h5 class="modal-heading">Filter</h5>
            <a href="" class="modal-dismiss" @click.prevent="closeModal">
              <i class="icon_close"></i>
            </a>
          </div>

          <FilterByBeautyProfile
            v-if="isProductMatchCategory && beautyProfile.length"
            ref="beauty"
            :list="beautyProfile"
            @selected="selectedBeauty"
          />

          <div v-if="options.available" class="section section--brands filter-group filter-group--by-brand">
            <h5 class="section__heading">Availibility</h5>

            <ul class="list">
              <li v-for="(avail, idx) in availibility" :key="idx" class="list__item">
                <input
                  :id="avail"
                  v-model="filterAvailChecked"
                  type="checkbox"
                  name="filter_brand_desktop"
                  :value="avail"
                  class="checkbox"
                />
                <label>{{ `Available at ${avail}` }}</label>
              </li>
            </ul>
          </div>
          <div v-if="options.brands" class="section section--brands filter-group--by-brand">
            <h5 class="section__heading">
              Brands
              <a href="" @click.prevent="seeAllBrands = true">Lihat Semua</a>
            </h5>
            <div class="section-brand-wrapper">
              <div class="search-with-icon">
                <input
                  type="text"
                  name="search"
                  class="form-control search-with-icon__input"
                  placeholder="Search brand..."
                  @keyup="onKeyupSearchbrand"
                  @focus="onFocusShowAllBrands"
                  @click.prevent="seeAllBrands = true"
                />
              </div>
              <template v-if="listSelectedBrand.brand.length">
                <p>Brand names :</p>
                <ul class="list-inline list-scrollable list-active-brand">
                  <li v-for="(brand, key) in listSelectedBrand.brand" :key="key">
                    <a href="" class="pill" @click.prevent>
                      {{ brand.name }}
                      <span class="pill-dismiss" @click.self="removeSelectedBrand(key, 0)"></span>
                    </a>
                  </li>
                </ul>
              </template>
              <template v-if="listSelectedBrand.origin.length">
                <p>Brand origins :</p>
                <ul class="list-inline list-scrollable list-active-brand">
                  <li v-for="(brand, key) in listSelectedBrand.origin" :key="key">
                    <a href="" class="pill" @click.prevent>
                      {{ brand.country }}
                      <span class="pill-dismiss" @click.self="removeSelectedBrand(key, 1)"></span>
                    </a>
                  </li>
                </ul>
              </template>
              <ul v-else-if="list_country && list_country.length" class="list-inline list-active-brand list-temp">
                <li v-for="(brand, key) in list_country.slice(0, 5)" :key="key">
                  <a href="" class="pill" @click.prevent="setSelectedOrigin(brand)">
                    {{ brand.country }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div v-if="options.rating" class="section section--price">
            <h5 class="section__heading">Ratings</h5>
            <ul class="list">
              <li class="list__item">
                <input id="rating_5" v-model="filterRating" type="radio" name="rating_desktop" value="5" />
                <label for="rating_5" class="radio-donut">
                  <div class="card-rating card-rating--normalize">
                    <div class="rating--uniform timeline-review">
                      <div class="rate-star--uniform rate-star--uniform-50">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                      <span class="card-average-rating">5</span>
                    </div>
                  </div>
                </label>
              </li>
              <li class="list__item">
                <input id="rating_4" v-model="filterRating" type="radio" name="rating_desktop" value="4" />
                <label for="rating_4" class="radio-donut">
                  <div class="card-rating card-rating--normalize">
                    <div class="rating--uniform timeline-review">
                      <div class="rate-star--uniform rate-star--uniform-40">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                      <span class="card-average-rating">4</span>
                    </div>
                  </div>
                </label>
              </li>
              <li class="list__item">
                <input id="rating_3" v-model="filterRating" type="radio" name="rating_desktop" value="3" />
                <label for="rating_3" class="radio-donut">
                  <div class="card-rating card-rating--normalize">
                    <div class="rating--uniform timeline-review">
                      <div class="rate-star--uniform rate-star--uniform-30">
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                      <span class="card-average-rating">3</span>
                    </div>
                  </div>
                </label>
              </li>
              <li class="list__item">
                <input id="rating_2" v-model="filterRating" type="radio" name="rating_desktop" value="2" />
                <label for="rating_2" class="radio-donut">
                  <input v-model="filterRating" type="radio" name="rating_desktop" value="2" />
                  <div class="card-rating card-rating--normalize">
                    <div class="rating--uniform timeline-review">
                      <div class="rate-star--uniform rate-star--uniform-20">
                        <span></span>
                        <span></span>
                      </div>
                      <span class="card-average-rating">2</span>
                    </div>
                  </div>
                </label>
              </li>
              <li class="list__item">
                <input id="rating_1" v-model="filterRating" type="radio" name="rating_desktop" value="1" />
                <label for="rating_1" class="radio-donut">
                  <div class="card-rating card-rating--normalize">
                    <div class="rating--uniform timeline-review">
                      <div class="rate-star--uniform rate-star--uniform-10">
                        <span></span>
                      </div>
                      <span class="card-average-rating">1</span>
                    </div>
                  </div>
                </label>
              </li>
              <li class="list__item">
                <input id="rating_0" v-model="filterRating" type="radio" name="rating_desktop" value="0" />
                <label for="rating_0" class="radio-donut">
                  <div class="card-rating card-rating--normalize">
                    <div class="rating--uniform timeline-review">
                      <div class="rate-star--uniform">
                        <span></span>
                      </div>
                      <span class="card-average-rating">0</span>
                    </div>
                  </div>
                </label>
              </li>
            </ul>
          </div>
        </template>
      </div>
    </div>
    <div class="modal-footer">
      <a href="" class="btn btn-apply-filter btn-apply-filter-reset" @click.prevent="reset">Reset</a>
      <a href="" class="btn btn-apply-filter" @click.prevent="apply">Apply filter</a>
    </div>
  </div>
</template>
<script>
/* eslint-disable vue/prop-name-casing */
import zenscroll from 'zenscroll';
import FilterByBeautyProfile from '@/components/global/filter-by-beauty-profile/filter-by-beauty-profile';
export default {
  name: 'modal-filter-search',
  components: {
    FilterByBeautyProfile,
  },
  props: {
    list_brands: {
      required: false,
      type: Array,
      default: () => [],
    },
    list_country: {
      required: false,
      type: Array,
      default: () => [],
    },
    brand_detail: {
      required: false,
      type: Object,
      default: () => {},
    },
    options: {
      required: false,
      type: Object,
      default: () => {
        return { available: true, brands: true, rating: true };
      },
    },
  },
  data() {
    return {
      isEmptyWhenTypingBrand: false,
      selectedBrand: [],
      selectedOrigin: [],
      listsBrandsFinals: [],
      listsOriginsFinals: [],
      brandSearchName: '',
      brandSearch: '',
      clickedBrand: '',
      seeAllBrands: false,
      searchText: '',
      queryString: {
        query: '',
        sortby: '',
        brand: '',
        origins: '',
        filter_rating: '',
        page: 1,
        available_for: '',
      },
      availibility: ['sociolla', 'lulla'],
      filterRating: '',
      filterAvailChecked: [],
      valueForQueryString: {
        brand_id: '',
        filter_rating: '',
        available_for: '',
      },
      activeTab: 0,
      selectedBeuatyProfile: [],
    };
  },
  computed: {
    query() {
      return this.$route.query.query;
    },
    showModalFilterSearch() {
      return this.$store.state.modal.isModalShow.filterSearch;
    },
    screen() {
      return this.$store.state.screen;
    },
    brandId() {
      return this.$route.params.brand_id;
    },
    originId() {
      return this.$route.params.origins_id;
    },
    categoryIdParam() {
      return Number(this.$route.params.category_id);
    },
    categoryNameParam() {
      return this.$route.params.category_name;
    },
    listSelectedBrand() {
      const filterBrands = [];
      const filterOrigins = [];
      this.listsBrandsFinals.forEach((brand) => {
        if (this.selectedBrand.includes(brand['_id'])) {
          filterBrands.push(brand);
        }
      });
      this.listsOriginsFinals.forEach((brand) => {
        const labelString = brand['country_tag_id'] || '';
        if (this.selectedOrigin.includes(labelString.toString())) {
          filterOrigins.push(brand);
        }
      });
      if (this.activeTab === 0) {
        return {
          brand: filterBrands,
          origin: filterOrigins,
          active: filterBrands,
        };
      } else {
        return {
          brand: filterBrands,
          origin: filterOrigins,
          active: filterOrigins,
        };
      }
    },
    filteredBrands() {
      let brands = this.listsBrandsFinals;
      if (this.activeTab === 1) {
        brands = this.listsOriginsFinals;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.isEmptyWhenTypingBrand = false;
      if (this.brandSearch && this.brandSearch.toString().length) {
        const newBrand = brands.filter((brand) => {
          return this.brandSearch
            .toString()
            .toLowerCase()
            .split(' ')
            .every((v) => brand.name.toLowerCase().includes(v));
        });
        if (!newBrand.length) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.isEmptyWhenTypingBrand = true;
        }
        return newBrand;
      } else {
        return brands;
      }
    },
    letters() {
      const letters = {
        '#': { isActive: false },
        a: { isActive: false },
        b: { isActive: false },
        c: { isActive: false },
        d: { isActive: false },
        e: { isActive: false },
        f: { isActive: false },
        g: { isActive: false },
        h: { isActive: false },
        i: { isActive: false },
        j: { isActive: false },
        k: { isActive: false },
        l: { isActive: false },
        m: { isActive: false },
        n: { isActive: false },
        o: { isActive: false },
        p: { isActive: false },
        q: { isActive: false },
        r: { isActive: false },
        s: { isActive: false },
        t: { isActive: false },
        u: { isActive: false },
        v: { isActive: false },
        w: { isActive: false },
        x: { isActive: false },
        y: { isActive: false },
        z: { isActive: false },
      };

      const isAlphabet = (char) => char.match(/^[A-Za-z]+$/);
      let key = 'name';
      if (this.activeTab === 1) {
        key = 'country';
      }
      this.filteredBrands
        .filter((item) => !item['isHidden'])
        .forEach((item) => {
          const firstChar =
            item[key][0] == ' ' ? item[key].replace(' ', '')[0].toLowerCase() : item[key][0].toLowerCase();
          const isAlpha = isAlphabet(firstChar);

          if (isAlpha) {
            letters[firstChar]['isActive'] = true;
          } else {
            letters['#']['isActive'] = true;
          }
        });

      return letters;
    },
    isProductMatchCategory() {
      return this.$route.name === 'ProductMatchCategory';
    },
    beautyProfile() {
      if (this.isProductMatchCategory) {
        const user = this.$store.state.auth.userProfile;
        if (user && user.beauty) {
          const tags = [];
          user.beauty.forEach((item) => {
            item.subtags.forEach((item2) => tags.push(item2));
          });
          return tags;
        }
      }
      return [];
    },
    urlPage() {
      if (this.isProductMatchCategory) {
        return `/our-curated-selection/${this.categoryIdParam}`;
      } else {
        return `/category/${this.categoryIdParam}/${this.categoryNameParam}`;
      }
    },
  },
  watch: {
    'list_brands.length': {
      immediate: true,
      handler: function (length) {
        if (length && this.listsBrandsFinals.length === 0) {
          // eslint-disable-next-line vue/no-mutating-props
          const brands = JSON.parse(JSON.stringify(this.list_brands));
          this.listsBrandsFinals = brands.sort((a, b) => {
            return (a['name'] || '').localeCompare(b['name'] || '');
          });
        }
      },
    },
    'list_country.length': {
      immediate: true,
      handler: function (length) {
        if (length && this.listsOriginsFinals.length === 0) {
          // eslint-disable-next-line vue/no-mutating-props
          const countries = JSON.parse(JSON.stringify(this.list_country));
          this.listsOriginsFinals = countries.sort((a, b) => {
            return (a['country'] || '').localeCompare(b['country'] || '');
          });
        }
      },
    },
    seeAllBrands(newVal) {
      if (newVal === true) {
        this.$nextTick(() => {
          this.$refs['typeBrand'].focus();
        });
      }
    },
    selectedBrand() {
      const brandsQuery = this.selectedBrand.join();
      if (this.selectedBrand && this.selectedBrand.length) {
        this.queryString.brand = brandsQuery;
      } else {
        this.queryString.brand = '';
      }
    },
    selectedOrigin() {
      const originsQuery = this.selectedOrigin.join();
      if (this.selectedOrigin && this.selectedOrigin.length) {
        this.queryString.origins = originsQuery;
      } else {
        this.queryString.origins = '';
      }
    },
    filterRating(newVal, oldVal) {
      if (newVal) {
        this.queryString.filter_rating = newVal;
      } else {
        this.queryString.filter_rating = oldVal;
      }
    },
    filterAvailChecked() {
      const availableForQuery = this.filterAvailChecked.join();
      if (this.filterAvailChecked && this.filterAvailChecked.length) {
        this.queryString.available_for = availableForQuery;
      } else {
        this.queryString.available_for = '';
      }
    },
    $route(to, from) {
      if (this.$route.query) {
        if (this.$route.query.brand) {
          this.selectedBrand = this.$route.query.brand.split(',');
        } else if (this.$route.query.brand_id) {
          this.selectedBrand = JSON.parse(this.$route.query.brand_id);
        }

        if (this.$route.query.origins) {
          this.selectedOrigin = this.$route.query.origins.split(',');
        } else if (this.$route.query.origins_id) {
          this.selectedOrigin = JSON.parse(this.$route.query.origins_id);
        }

        if (this.$route.query.available_for && this.$route.name === 'Search') {
          this.filterAvailChecked = this.$route.query.available_for.split(',');
        } else if (this.$route.query.available_for && this.$route.name === 'Category') {
          this.filterAvailChecked = JSON.parse(this.$route.query.available_for);
        } else if (this.$route.query.available_for && this.$route.name === 'BrandDetail') {
          this.filterAvailChecked = JSON.parse(this.$route.query.available_for);
        }

        if (this.$route.query.filter_rating) {
          this.filterRating = this.$route.query.filter_rating;
        }
      }
    },
  },
  created() {
    if (this.$route.query) {
      if (this.$route.query.brand) {
        this.selectedBrand = this.$route.query.brand.split(',');
      } else if (this.$route.query.brand_id) {
        this.selectedBrand = JSON.parse(this.$route.query.brand_id);
      }

      if (this.$route.query.origins) {
        this.selectedOrigin = this.$route.query.origins.split(',');
      } else if (this.$route.query.origins_id) {
        this.selectedOrigin = JSON.parse(this.$route.query.origins_id);
      }

      if (this.$route.query.available_for && this.$route.name === 'Search') {
        this.filterAvailChecked = this.$route.query.available_for.split(',');
      } else if (this.$route.query.available_for && this.$route.name === 'Category') {
        this.filterAvailChecked = JSON.parse(this.$route.query.available_for);
      } else if (this.$route.query.available_for && this.$route.name === 'BrandDetail') {
        this.filterAvailChecked = JSON.parse(this.$route.query.available_for);
      }

      if (this.$route.query.filter_rating) {
        this.filterRating = this.$route.query.filter_rating;
      }
      if (this.$route.query.beauty) {
        this.selectedBeuatyProfile = this.$route.query.beauty.split(',');
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$route.query && this.$route.query.beauty) {
        this.$refs.beauty.setSelected(this.selectedBeuatyProfile);
      }
    });
  },
  beforeDestroy() {
    this.listsBrandsFinals.forEach((brand) => (brand['isHidden'] = false));
  },
  methods: {
    checkActiveTab() {
      if (this.activeTab === 0) {
        return this.list_brands;
      }
      if (this.activeTab === 1) {
        return this.list_country;
      }
    },
    buildIdElBrand(brand, idx) {
      const isAlphabet = (char) => char.match(/^[A-Za-z]+$/);
      let list = 'listsBrandsFinals';
      let key = 'name';
      if (this.activeTab === 1) {
        list = 'listsOriginsFinals';
        key = 'country';
      }
      const prevBrand = idx > 0 ? this[list][idx - 1] : null;
      const brandFirstChar = brand[key][0].toLowerCase();
      const isAlpha = isAlphabet(brandFirstChar);

      if (isAlpha) {
        if (prevBrand !== null && prevBrand[key][0].toLowerCase() !== brandFirstChar) {
          return 'brand-' + brandFirstChar;
        }
      } else if (!isAlpha && prevBrand === null) {
        return 'brand-#';
      }

      return '';
    },
    setSelectedOrigin(brand) {
      this.selectedOrigin.push(brand.country_tag_id);
    },
    setRouteQueryString(a, b) {
      const obj_1 = Object.getOwnPropertyNames(a);
      const obj_2 = Object.getOwnPropertyNames(b);

      if (obj_1.length != obj_2.length) {
        return false;
      }

      for (let i = 0; i < obj_1.length; i++) {
        const attr = obj_1[i];
        if (a[attr] !== b[attr]) {
          return false;
        }
      }

      return true;
    },
    apply() {
      let query = Object.assign({}, this.$route.query);

      if (this.$route.name == 'Search') {
        if (this.queryString.sortby) {
          query = Object.assign(query, { sortby: this.queryString.sortby });
        } else {
          if (query.sortby) {
            delete query.sortby;
          }
        }

        if (this.queryString.brand) {
          query = Object.assign(query, { brand: this.queryString.brand });
        } else {
          if (query.brand) {
            delete query.brand;
          }
        }

        if (this.queryString.origins) {
          query = Object.assign(query, { origins: this.queryString.origins });
        } else {
          if (query.origins) {
            delete query.origins;
          }
        }

        if (this.queryString.available_for) {
          query = Object.assign(query, {
            available_for: this.queryString.available_for,
          });
        } else {
          if (query.available_for) {
            delete query.available_for;
          }
        }

        query.page = 1;

        if (this.queryString.filter_rating) {
          query = Object.assign(query, {
            filter_rating: this.queryString.filter_rating,
          });
        } else {
          if (query.filter_rating) {
            delete query.filter_rating;
          }
        }

        if (!this.setRouteQueryString(this.$route.query, query)) {
          this.$router.push({ query: query });
        }
      } else if (this.$route.name == 'Category' || this.$route.name == 'ProductMatchCategory') {
        const queryStringss = this.buildQueryString();
        const changedPathValuess = `${this.urlPage}?${this.buildQueryString()}`;

        if (queryStringss && this.$route.fullPath !== changedPathValuess) {
          this.$router.push(changedPathValuess);
        }

        if (!queryStringss) {
          this.$router.push(`${this.urlPage}?${this.buildQueryString()}`);
        }
      } else {
        const queryString = this.buildQueryString();
        const changedPathValue = `${this.$route.path}?${this.buildQueryString()}`;

        if (queryString && this.$route.fullPath !== changedPathValue) {
          this.$router.push(changedPathValue);
        }

        if (!queryString) {
          this.$router.push(`/brand/${this.brandId}/${this.$options.filters.slug(this.brand_detail.data.name)}`);
        }
      }
      this.closeModal();
    },
    buildQueryString() {
      const objectForQueryString = {};

      if (this.filterRating) {
        objectForQueryString.filter_rating = this.filterRating;
      }
      // else if (this.$route.query.filter_rating) {
      // 	this.valueForQueryString.filter_rating = this.$route.query.filter_rating
      // 	objectForQueryString.filter_rating = this.valueForQueryString.filter_rating
      // }

      if (this.selectedBrand && this.selectedBrand.length) {
        objectForQueryString.brand_id = this.selectedBrand;
      }

      if (this.selectedOrigin && this.selectedOrigin.length) {
        objectForQueryString.origins_id = this.selectedOrigin;
      }
      // else if (this.$route.query.brand_id) {
      // 	this.valueForQueryString.brand_id = this.$route.query.brand_id
      // 	objectForQueryString.brand_id = this.valueForQueryString.brand_id
      // }

      if (this.filterAvailChecked && this.filterAvailChecked.length) {
        objectForQueryString.available_for = this.filterAvailChecked;
      }

      if (this.selectedBeuatyProfile.length) {
        objectForQueryString.beauty = this.selectedBeuatyProfile.join(',');
      }
      // else if (this.$route.query.available_for) {
      // 	this.valueForQueryString.available_for = this.$route.query.available_for
      // 	objectForQueryString.available_for = this.valueForQueryString.available_for;
      // }
      return this.$options.filters.serializeQS(objectForQueryString);
    },
    onKeyupSearchbrand(e) {
      let list = 'listsBrandsFinals';
      let keys = 'name';
      if (this.activeTab === 1) {
        list = 'listsOriginsFinals';
        keys = 'country';
      }

      const value = e.target.value.toLowerCase();
      const totalBrands = this[list].length;
      let i = 0;

      if (value.length > 0) {
        this.seeAllBrands = true;
      } else {
        this.seeAllBrands = false;
      }

      this.brandSearchName = value;
      this[list].forEach((brand, key) => {
        const brandNameToLowerCase = brand[keys].toLowerCase();

        if (brandNameToLowerCase.includes(value)) {
          this.$set(this[list][key], 'isHidden', false);
        } else {
          this.$set(this[list][key], 'isHidden', true);
          i++;
        }
      });

      this.isEmptyWhenTypingBrand = i === totalBrands;
    },
    scrollToBrandMenu(item) {
      const defaultDuration = 400;
      const edgeOffset = 0;
      const myDiv = document.getElementById('brand-list-by-filter');
      const myScroller = zenscroll.createScroller(myDiv, defaultDuration, edgeOffset);
      const char = item.split('-').splice(1, 1)[0];
      const newElm = document.getElementsByClassName('for-br-' + char)[0];

      this.$set(this, 'clickedBrand', char);

      myScroller.toY(newElm.offsetTop - 100);
    },
    removeSelectedBrand(key, activeTab) {
      if (activeTab === 0) {
        this.selectedBrand.splice(key, 1);
      }
      if (activeTab === 1) {
        this.selectedOrigin.splice(key, 1);
      }
    },
    reset() {
      this.filterRating = '';
      this.filterAvailChecked = [];
      this.selectedBrand = [];
      this.selectedOrigin = [];
      this.selectedBeuatyProfile = [];
      if (this.$refs.beauty) {
        this.$refs.beauty.reset();
      }
      if (this.$route.name == 'Category' || this.$route.name == 'ProductMatchCategory') {
        this.$router.push(`${this.urlPage}`);
      } else if (this.$route.name == 'Search') {
        this.$router.push(`/search?query=${this.query}`);
      } else if (this.$route.name == 'BrandDetailOrigin') {
        this.$router.push(`/brand/${this.brandId}-${this.$options.filters.slug(this.brand_detail.data.country)}`);
      } else {
        this.$router.push(`/brand/${this.brandId}/${this.$options.filters.slug(this.brand_detail.data.name)}`);
      }
    },
    closeModal() {
      this.$store.commit('toggleModalGlobalState', {
        modalName: 'filterSearch',
      });
    },
    onFocusShowAllBrands() {
      if (!this.seeAllBrands && this.brandSearchName.length > 0) {
        this.seeAllBrands = true;
      }
    },
    showAllBrands() {
      this.seeAllBrands = true;
    },
    selectedBeauty(selected) {
      this.selectedBeuatyProfile = [...selected];
    },
  },
};
</script>

<style lang="scss" scoped>
@import './_modal-filter';
</style>
